const subs = {
    actualFmp: {},
};
function unsubscribe(metricId, subId) {
    delete subs[metricId][subId];
}
export function publish(metricId, value) {
    if (subs[metricId] && typeof subs[metricId] === 'object') {
        Object.keys(subs[metricId]).forEach((subId) => {
            subs[metricId][subId](value);
        });
    }
}
export function subscribe(metricId, observer) {
    const subId = `sub_${metricId}_${Date.now()}_${Math.floor(Math.random() * 10000)}`;
    if (subs[metricId] && typeof subs[metricId] === 'object') {
        subs[metricId][subId] = observer;
        return {
            unsubscribe: () => unsubscribe(metricId, subId),
        };
    }
    return {
        unsubscribe: () => { },
    };
}
//# sourceMappingURL=metricSubscription.js.map